/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { Dialog } from "primereact/dialog";
import { formatFecha, Boton } from "../../shared";

export default function PasosAnteriores({ pasosAnteriores }) {
  const [dialogComentario, setDialogComentario] = useState(false);
  const [comentarioCompleto, setComentarioCompleto] = useState("");

  const customizedContent = (decision) => {
    const auditor = decision?.actividadpaso_x_auditordecisor?.auditor;
    const administrador = decision?.administrador;

    return (
      <Card className="mb-3">
        <div css={{ display: "flex", flexDirection: "column", gap: "0.75em" }}>
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3
              css={{ margin: 0 }}
              className="lg:block md:hidden sm:hidden xl:block hidden"
            >
              {formatFecha(decision.fechadecision)}
            </h3>
            <Tag
              value={decision.aprobado ? "Aprobado" : "Rechazado"}
              severity={decision.aprobado ? "success" : "danger"}
            />
          </div>

          {decision.comentarios && (
            <div
              css={{
                padding: "0.5em",
                backgroundColor: "#f8f9fa",
                borderRadius: "4px",
              }}
            >
              <p
                css={{
                  margin: 0,
                  whiteSpace: "pre-wrap",
                  fontSize: "0.9rem"
                }}
              >
                {decision.comentarios.length > 150
                  ? decision.comentarios.substring(0, 150) + "..."
                  : decision.comentarios}
              </p>
              {decision.comentarios.length > 150 && (
                <Boton
                  texto
                  amarillo
                  callback={(e) => {
                    e.stopPropagation();
                    setComentarioCompleto(decision.comentarios);
                    setDialogComentario(true);
                  }}
                >
                  Ver más
                </Boton>
              )}
            </div>
          )}

          {decision.fechadecision && (
            <small className="text-500 lg:hidden md:block sm:block xl:hidden block">
              <strong>Decisión: </strong>
              {formatFecha(decision.fechadecision)}
            </small>
          )}
          {auditor && (
            <small className="text-500">
              <strong>Auditor:</strong> {auditor.nombre} {auditor.apellido}
            </small>
          )}

          {administrador && (
            <small className="text-500">
              <div css={{ color: "var(--amarillo)" }}>
                <strong>Decisión Administrativa</strong>
              </div>
              <strong>Administrador:</strong> {administrador.nombre}{" "}
              {administrador.apellido}
            </small>
          )}
        </div>
      </Card>
    );
  };

  const customizedOpposite = (decision) => {
    let paso;
    if (decision.actividadpaso_x_auditordecisor?.actividadpaso) {
      paso = decision.actividadpaso_x_auditordecisor.actividadpaso;
    } else {
      paso = decision.actividadpaso;
    }
    return (
      <div css={{ marginTop: "10px" }}>{paso.nombre}</div>
    );
  };

  const customizedMarker = (decision) => {
    return (
      <span
        css={{
          display: "flex",
          width: "2rem",
          height: "2rem",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          borderRadius: "50%",
          backgroundColor: decision.aprobado
            ? "var(--verde)"
            : "var(--rojo)",
          boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.2)",
        }}
      >
        <i className={decision.aprobado ? "pi pi-check" : "pi pi-times"}></i>
      </span>
    );
  };

  return (
    <>
      <Dialog
        header="Comentario"
        visible={dialogComentario}
        onHide={() => setDialogComentario(false)}
        style={{ width: "50rem" }}
        breakpoints={{ "960px": "75vw", "641px": "95vw" }}
      >
        <p css={{ whiteSpace: "pre-wrap", margin: 0 }}>{comentarioCompleto}</p>
      </Dialog>
      <div css={{ padding: "1em" }}>
        {pasosAnteriores && pasosAnteriores.length > 0 ? (
          <Timeline
            value={pasosAnteriores}
            opposite={customizedOpposite}
            content={customizedContent}
            marker={customizedMarker}
          />
        ) : (
          <p>No hay decisiones anteriores registradas</p>
        )}
      </div>
    </>
  );
}
